@if (isInitialized) {
  <oe-chart [(showPhases)]="showPhases" [period]="service.historyPeriod.value" [title]="'EDGE.INDEX.WIDGETS.FIX_DIGITAL_OUTPUT' | translate">
    <totalChart [isOnlyChart]="true"></totalChart>
  </oe-chart>
}
@if (isInitialized) {
  <oe-footer-subnavigation
  [navigationOptions]="navigationButtons"></oe-footer-subnavigation>
}
